import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig'; // Aapke Firebase ka sahi path
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Sparkles } from 'lucide-react'; 

const AIUsageGraph = () => {
    const [usageData, setUsageData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUsageData = async () => {
            try {
                const clientsSnapshot = await getDocs(collection(db, "clients"));
                let dataArray = [];

                clientsSnapshot.forEach(doc => {
                    const client = doc.data();
                    if (client.total_ai_calls && client.total_ai_calls > 0) {
                        dataArray.push({
                            name: client.name ? client.name.substring(0, 15) + "..." : "Client",
                            calls: client.total_ai_calls || 0
                        });
                    }
                });

                dataArray.sort((a, b) => b.calls - a.calls);
                setUsageData(dataArray.slice(0, 7)); // Top 7 clients dikhayenge
                setLoading(false);
            } catch (error) {
                console.error("Chart Fetch Error:", error);
                setLoading(false);
            }
        };
        fetchUsageData();
    }, []);

    if (loading) return <div className="p-8 text-center text-slate-400 text-xs font-bold uppercase tracking-widest animate-pulse">Loading AI Metrics...</div>;

    return (
        <div className="p-6 md:p-8 bg-white w-full">
            <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-xl bg-indigo-50 flex items-center justify-center text-indigo-600">
                    <Sparkles className="w-5 h-5" />
                </div>
                <div>
                    <h3 className="text-sm md:text-base font-black text-slate-800 tracking-tight">AI Engine Usage</h3>
                    <p className="text-[10px] md:text-xs font-bold text-slate-400 uppercase tracking-wider">Top clients consuming API</p>
                </div>
            </div>

            {usageData.length === 0 ? (
                <div className="text-center py-10 text-xs font-bold text-slate-400 uppercase tracking-widest bg-slate-50 rounded-2xl border border-dashed border-slate-200">
                    No AI Calls Recorded Yet
                </div>
            ) : (
                <div className="h-64 w-full mt-4">
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={usageData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
                            <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fill: '#94a3b8', fontSize: 10, fontWeight: 600 }} />
                            <YAxis axisLine={false} tickLine={false} tick={{ fill: '#94a3b8', fontSize: 10, fontWeight: 600 }} />
                            <Tooltip 
                                cursor={{ fill: '#f8fafc' }}
                                contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)', fontWeight: 'bold', fontSize: '12px' }}
                            />
                            <Bar dataKey="calls" fill="#6366f1" radius={[6, 6, 0, 0]} barSize={32} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            )}
        </div>
    );
};

export default AIUsageGraph;